<template>
  <template v-if="subcol.select">
    <div :style="{ width: subcol.width ?? '360px' }">
      <jw-input-group class="xl-search-input-wrap">
        <jw-select :style="{ width: '30%' }" v-model="selectVal" @change="changeSelect" :placeholder="subcol.select.placeholder || $t('请选择')" :allow-clear="subcol.select.allowClear || false" :multiple="subcol.select.multiple === true ? true : false" :max-tag-count="subcol.select.maxTagCount === undefined ? 1 : subcol.select.maxTagCount" :bordered="subcol.select.bordered === false ? false : true" :allow-search="allowSearch" :options="options" :field-names="subcol.select.dataProps" unmount-on-close>
          <!-- <jw-option v-for="item of options" :key="item[subcol.select?.dataProps?.value || 'value']" :value="item[subcol.select?.dataProps?.value || 'value']" :label="item[subcol.select?.dataProps?.label || 'label']" :title="item[subcol.select?.dataProps?.label || 'label']" /> -->
          <template #option="{ data }">
            <span :title="data.label">
              {{ data.label }}
            </span>
          </template>
        </jw-select>
        <jw-input-search ref="inputSelectSearchRef" :style="{ width: '70%' }" v-model.trim="iptVal" :placeholder="subcol.placeholder || $t('请输入')" :allow-clear="subcol.allowClear === false ? false : true" @change="changeVal" @search="inputSearchBlur">
          <template v-if="subcol.prepend" #prepend>{{ subcol.prepend }}</template>
          <template v-if="subcol.append" #append>{{ subcol.append }}</template>
        </jw-input-search>
      </jw-input-group>
    </div>
  </template>
  <template v-else>
    <jw-input-search ref="inputSearchRef" v-model.trim="iptVal" :style="{ width: subcol.width ?? '260px' }" :placeholder="subcol.placeholder || $t('请输入')" @change="changeVal" @search="inputSearchBlur" :allow-clear="subcol.allowClear === false ? false : true">
      <template v-if="subcol.prepend" #prepend>{{ subcol.prepend }}</template>
      <template v-if="subcol.append" #append>{{ subcol.append }}</template>
    </jw-input-search>
  </template>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
const props = defineProps({
  subcol: {
    type: Object,
    default() {
      return {};
    }
  }
});
const emits = defineEmits(['cb']);
const iptVal = ref(props.subcol?.value || '');
const selectVal = ref(props.subcol?.select?.value || '');
const o = ref({});
// selects
const options = computed(() => {
  if (props.subcol?.select?.data) {
    return props.subcol?.select?.data?.filter((item) => item.fieldKey != 'businessId');
  } else {
    return [];
  }
});
// const options = ref(props.subcol?.select?.data || []);
const inputSelectSearchRef = ref();
const inputSearchRef = ref();
// 是否允许搜索，单选默认不允许，多选默认允许，用户可以自己定义是否允许
const allowSearch = computed(() => {
  let flag = false;
  if (props.subcol?.select?.multiple) flag = true;
  else flag = false;
  if (props.subcol?.select?.allowSearch === false) flag = false;
  if (props.subcol?.select?.allowSearch === true) flag = true;
  return flag;
});

watch(
  () => props.subcol,
  () => {
    iptVal.value = props.subcol?.value || '';
    selectVal.value = props.subcol?.select?.value || '';
  },
  {
    deep: true
  }
);

// 在有select情况下 是否联动删除select值
const isLinkage = computed(() => props.subcol?.select?.isLinkage);
// 点击搜索图标失去焦点
const inputSearchBlur = () => {
  inputSelectSearchRef.value?.blur?.();
  inputSearchRef.value?.blur?.();
};
// input 事件
const changeVal = (v) => {
  o.value = {};
  console.log(58, v);
  console.log(59, selectVal.value);
  if (!iptVal.value) {
    o.value[props.subcol.name] = undefined;
    console.log(61, isLinkage.value);
    if (isLinkage.value !== false) {
      selectVal.value = '';
    }
  } else {
    o.value[props.subcol.name] = { val: iptVal.value };
    if (props.subcol.select) {
      o.value[props.subcol.name]['selectVal'] = selectVal.value;
    }
  }
  emits('cb', o.value);
};
// select 事件
const changeSelect = (v) => {
  console.log(88, v);
  if (iptVal.value) {
    changeVal();
  }
};
</script>
<style scoped lang="less">
@import './xl-input.less';
</style>
